<template>
  <div>
    <v-layout row v-if="error">
      <v-flex xs12 sm10 offset-sm1 md6 offset-md3>
        <app-alert @dismissed="dismiss" :text="error.message"></app-alert>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12 sm10 offset-sm1 md6 offset-md3>
        <h3 class="headline mb-3">Reset Password</h3>
        <transition name="fade-in">
          <div v-if="passwordChanged" key="changed">
            <p>Password changed. You can now
              <router-link :to="{ name: 'login' }">sign in</router-link>.
            </p>
          </div>
          <div v-else key="changing">
            <p>Please enter a new password below in order to reset it.</p>
            <v-card light class="mb-5">
              <v-card-text v-if="!passwordChanged">
                <!-- <v-container> -->
                <v-form
                  @submit.prevent="onSubmit"
                  v-model="valid"
                  ref="form"
                  lazy-validation
                  class="mb-5 pb-5"
                >
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-text-field
                        name="password"
                        label="Password"
                        hint="Minimum 8 characters, at least 1 uppercase letter, 1 lowercase letter, 1 number and 1 special character @$!%*#&^"
                        :min="minPasswordLength"
                        ref="password"
                        required
                        :rules="[rules.required, rules.passwordValid]"
                        v-model="password"
                        :append-icon="passwordVisibile ? 'visibility_off' : 'visibility'"
                        :append-icon-cb="() => (passwordVisibile = !passwordVisibile)"
                        :type="passwordVisibile ? 'text' : 'password'"
                        hide-details
                      ></v-text-field>

                      <v-progress-linear
                        value="0"
                        height="5"
                        color="grey"
                        v-model="passwordStrength"
                        :data-score="passwordStrength"
                      ></v-progress-linear>

                      <v-text-field
                        name="password-conf"
                        label="Confirm Password"
                        hint="Minimum 8 characters, at least 1 uppercase letter, 1 lowercase letter, 1 number and 1 special character @$!%*#&^"
                        :min="minPasswordLength"
                        ref="passwordConfirm"
                        required
                        v-model="passwordConfirm"
                        :append-icon="passwordVisibile ? 'visibility_off' : 'visibility'"
                        :append-icon-cb="() => (passwordVisibile = !passwordVisibile)"
                        :rules="[rules.matches]"
                        :type="passwordVisibile ? 'text' : 'password'"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row align-top>
                    <v-flex xs6 class="text-xs-left">
                      <v-btn @click="goBack" class="ml-0" outline color="secondary">&laquo; Back</v-btn>
                    </v-flex>
                    <v-flex xs6 class="text-xs-right">
                      <v-btn
                        outline
                        primary
                        type="submit"
                        :loading="loading"
                        :disabled="loading === true || valid === false"
                        class="mr-0"
                      >Send</v-btn>
                    </v-flex>
                  </v-layout>
                </v-form>
                <!-- </v-container> -->
              </v-card-text>
            </v-card>
          </div>
        </transition>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { HTTP } from "@/http-common";
import zxcvbn from "zxcvbn";
export default {
  data() {
    return {
      valid: true,
      loading: false,
      token: null,
      password: "",
      passwordConfirm: "",
      passwordVisibile: false,
      passwordChanged: false,
      minPasswordLength: 8,
      error: null,
      rules: {
        required: v => {
          return !!v || "Required";
        },
        matches: () => {
          return this.passwordsMatch || "Password's must match.";
        },
        passwordValid(v) {
          return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#&^])[A-Za-z\d@$!%*#&^]{8,}$/.test(v);
        }
      }
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    // error () {
    //   return this.$store.getters.error
    // },
    passwordStrength() {
      return this.password ? zxcvbn(this.password).score : null;
    },
    isSecure() {
      return this.password
        ? this.password.length >= this.minPasswordLength
        : null;
    },
    passwordsMatch() {
      return (
        this.password !== "" &&
        this.passwordConfirm !== "" &&
        this.password === this.passwordConfirm
      );
    }
  },
  mounted() {
    if (!this.$route.params.token) {
      this.$router.replace({ name: "forgot-password", query: { expired: 1 } });
    } else {
      this.token = this.$route.params.token;
    }
  },
  methods: {
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.dismiss();

        HTTP.post("/reset-password", {
          token: this.token,
          password: this.password
        })
          .then(response => {
            this.loading = false;
            this.passwordChanged = true;
          })
          .catch(e => {
            this.loading = false;
            this.error = e.response.data.error;
          });
      } else {
        console.log("invalid...");
      }
    },
    dismiss() {
      this.error = null;
    }
  }
};
</script>

<style scoped>
.progress-linear[data-score="0"] /deep/ .progress-linear__bar__determinate {
  background: darkred !important;
  width: 20% !important;
}
.progress-linear[data-score="1"] /deep/ .progress-linear__bar__determinate {
  background: orangered !important;
  width: 40% !important;
}
.progress-linear[data-score="2"] /deep/ .progress-linear__bar__determinate {
  background: orange !important;
  width: 60% !important;
}
.progress-linear[data-score="3"] /deep/ .progress-linear__bar__determinate {
  background: yellowgreen !important;
  width: 80% !important;
}
.progress-linear[data-score="4"] /deep/ .progress-linear__bar__determinate {
  background: green !important;
  width: 100% !important;
}

.fade-in-enter-active,
.fade-in-leave-active {
  transition: opacity 0.5s;
}
.fade-in-enter, .fade-in-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/user/ResetPassword.vue